<template>
<div>

  <el-row :gutter="20">
      <el-col :md="7" :lg="5">
          <el-select v-model="chose_type" @change="TypeHandle" placeholder="请选择统计方式"
                     style="width: 100%;" size="mini">
              <el-option
                      v-for="(item, index) in select_type"
                      :key="index"
                      :label="item.name"
                      :value="item.value">
              </el-option>
          </el-select>
      </el-col>


      <el-col :md="10" :lg="8">
          <el-date-picker v-model="create_time" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
      </el-col>
    <el-button type="primary" @click="exportDataA"> 导出当前数据</el-button>

  </el-row>
      <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="统计信息" name="admin"></el-tab-pane>
      <el-table :data="list" :height="wheight-160" v-loading="loading">

        <el-table-column prop="username" label="用户名"></el-table-column>
        <el-table-column prop="mobile" label="用户手机"></el-table-column>
        <el-table-column prop="realname" label="用户实名"></el-table-column>
        <el-table-column prop="create_time" label="领取时间">
              <template slot-scope="scope">
                  {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}
              </template>
        </el-table-column>
          <el-table-column prop="type" label="领取类型">
              <template slot-scope="scope">
                  <el-tag v-if="scope.row.type == '1'" size="mini">线下领券</el-tag>
                  <el-tag v-else="scope.row.type == '2'" size="mini">线上领钱</el-tag>
              </template>
          </el-table-column>
        <el-table-column prop="name" label="店铺"></el-table-column>
        <el-table-column prop="number" label="店铺id"></el-table-column>

      </el-table>
      <div  class="content-padded content-center">
          <div  class="content-padded content-center">
              <el-pagination background
                             layout="prev, pager, next, total"
                             @current-change="handleCurrentChange"
                             :current-page.sync="params.page"
                             :total="total_count" :page-size="params.pageSize">
              </el-pagination>
          </div>
      </div>
    </el-tabs>
      </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import {nzyyActivityLog,nzyyActivityLogExport} from '../../../../api/marketing'

    export default {
        data () {
            return {
                clickable:false,
                dialog: false,
                activeName: 'admin',
                list: [],
                total_count: 0,
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    chose_type:'1',
                },
                chose_type:'',
                time_start_begin: '',
                time_start_end: '',
                create_time:'',

                select_type: [
                    {name: '线下领券', value: '1'},
                    {name: '线上零钱', value: '2'}
                ],

            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleCurrentChange (val) {
                this.currentPage = val
                this.loading = false
                this.getList()
            },
            getList () {
                this.loading = true
                if(this.params.chose_type == ''){
                    this.$message({
                        type: 'error',
                        message: '请选择统计方式'
                    })
                    return false
                }
                nzyyActivityLog(this.params).then(response => {
                    if(response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count =response.data.data.total

                    }
                    this.loading = false
                })
            },
            TypeHandle (val) {
                this.params.page = 1

                this.getParams()
                this.getList(this.params)
            },
            getParams(){
                this.params.time_start_begin = this.time_start_begin
                this.params.time_start_end = this.time_start_end
                this.params.chose_type = this.chose_type
            },
            dateChange (val) {
                if (val.length > 0) {
                    this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
                    this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
                } else {
                    this.time_start_begin = ''
                    this.time_start_end = ''
                }
                this.params.page = 1
                this.getParams()
                this.getList(this.params)
            },
            dateStrToTimeStamp (str) {
                return Date.parse(new Date(str))/1000
            },
            exportDataA(){
              // 导出数据
                nzyyActivityLogExport(this.params).then(response => {
                    //console.log(response.data)
                    if(response.data) {
                        var a = document.createElement('a')
                        a.href = response.data.url
                        a.download = response.data.filename
                        a.click()
                    }
                })
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style scoped lang="scss">
  .upload-preview {
    text-align: center;
    max-width: 200px;
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
    img {
      max-width: 200px;
      margin: 0 auto;
    }
  }
  .text-ellipsis {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .vue-html5-editor {
    vertical-align: top;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// nzyylog.vue?43dd7d23